import React from 'react'
import { Icon } from '@chakra-ui/react'

export function IconMoon(rest) {
  return (
    <Icon viewBox="0 0 24 24" {...rest}>
      <path
        stroke="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        fill="currentColor"
        d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"
      />
    </Icon>
  )
}
